import { render, staticRenderFns } from "./dark-button.vue?vue&type=template&id=32514cfc&scoped=true&"
import script from "./dark-button.vue?vue&type=script&lang=js&"
export * from "./dark-button.vue?vue&type=script&lang=js&"
import style0 from "./dark-button.vue?vue&type=style&index=0&id=32514cfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32514cfc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
